














































































import { computed, defineComponent, ref } from '@vue/composition-api'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import vClickOutside from 'v-click-outside'
import { useGetters } from '../../store/useGetters'
import colorScheme from '../../colorScheme'
import { useActions } from '../../store/useActions'
import Popup from '../../components/popup/Popup.vue'

export default defineComponent({
  name: 'SpeakerSelector',
  components: { Popup, FontAwesomeIcon },
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    root: {
      //TODO: remove root el
      required: true
    }
  },
  setup() {
    const { speakers, selectorShown, popupTarget } = useGetters({
      speakers: 'editor/suggestedSpeakers',
      selectorShown: 'editor/selectorShown',
      popupTarget: 'editor/selectorTarget'
    })

    const { hideSelector, create, remove, select, unselect } = useActions({
      hideSelector: 'editor/hideSpeakerSelector',
      create: 'editor/createAndSelectSpeaker',
      remove: 'editor/deleteSpeaker',
      select: 'editor/selectSpeaker',
      unselect: 'editor/unselectSpeaker'
    })

    const speakerName = ref('')
    const nameIsEmpty = computed(() => speakerName.value.length === 0)

    const clickAwayConfig = {
      handler: hideSelector,
      middleware: (event: any) =>
        !event.target.closest('.ignore-click-outside'),
      events: ['click']
    }

    function addSpeaker() {
      create(speakerName.value)
      speakerName.value = ''
    }

    return {
      trashIcon: faTrash,
      clickAwayConfig,
      popupTarget,

      selectorShown,

      speakerName,
      nameIsEmpty,

      speakers,
      remove,
      select,
      unselect,
      addSpeaker,

      colorScheme
    }
  }
})
